import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function CTAButton({
  children,
  href,
  onClick,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'font-heading font-bold uppercase tracking-wide text-center cursor-pointer transition-all duration-300 block w-full';
  const variantClasses = variant === 'primary' ? 'bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl lg:text-3xl py-5 md:py-6 px-8 md:px-12 rounded-lg cta-glow hover:scale-105' : 'bg-gold-500 hover:bg-gold-600 text-black text-lg md:text-xl lg:text-2xl py-4 md:py-5 px-6 md:px-10 rounded-lg hover:scale-105';
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      if (href.startsWith('#')) {
        const el = document.getElementById(href.replace('#', ''));
        if (el) el.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        window.open(href, '_blank');
      }
    }
  };
  return <button onClick={handleClick} className={`${baseClasses} ${variantClasses} ${className}`} type="button" data-id="element-18">
      {children}
    </button>;
}